(() => {
  function initGalleryMobileNav(root) {
    try {
      const carousel = root.querySelector('media-carousel');
      if (!carousel) return;

      // Only on small screens
      if (window.matchMedia('(min-width: 1000px)').matches) return;

      const id = carousel.getAttribute('id');
      const prev = root.querySelector(`#${id}-nav-prev`);
      const next = root.querySelector(`#${id}-nav-next`);
      if (!prev || !next) return;

      // media-carousel exposes next/prev methods on the element in many Impact forks; fallback to scrolling
      const goPrev = () => {
        if (typeof carousel.prev === 'function') {
          carousel.prev();
        } else {
          carousel.scrollBy({ left: -carousel.clientWidth, behavior: 'smooth' });
        }
      };
      const goNext = () => {
        if (typeof carousel.next === 'function') {
          carousel.next();
        } else {
          carousel.scrollBy({ left: carousel.clientWidth, behavior: 'smooth' });
        }
      };

      prev.addEventListener('click', goPrev);
      next.addEventListener('click', goNext);
    } catch (e) {
      // silent
    }
  }

  function initAll() {
    document.querySelectorAll('product-gallery').forEach(initGalleryMobileNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

